var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-banner",style:({
    display: _vm.extraItem.extras('banner.display') == 1 ? 'block' : 'none'
  })},[_c('img',{attrs:{"src":_vm.extraItem.extras('banner.src') ? _vm.extraItem.extras('banner.src') : '',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }